import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import classes from './SecurityLog.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import api from '../../axios-local-api';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { FaSpinner } from 'react-icons/fa';
import { FaSortUp, FaSortDown, FaInfoCircle, FaSync } from 'react-icons/fa';
import Countdown, { zeroPad } from 'react-countdown-now';
import Moment from 'react-moment';
import DeviceIcon from '../../components/UI/DeviceIcon/DeviceIcon';
import { sortDataByKey } from '../../shared/utility';
import Modal from '../../components/UI/Modal/Modal';

export class SecurityLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalType: null,
      modal: false,
      checked: false,
      progress: false,
      upArrows: [],
      upArrowsM: false,
      upArrowsCreate: false,
      sortBy: '',
      sortDirection: '',
      displayLogId: '',
      currentPage: 1,
      itemsPerPage: 10,
      currentRecords: this.buildDeviceSecurityThreatsData(props),
    };
    this.getSecurityLog = this.getSecurityLog.bind(this);
    this.makeRendererFn = this.makeRendererFn.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.setState({
      rendererFn: this.makeRendererFn(),
    });
    if (
      this.props.location &&
      this.props.location.query &&
      this.props.location.query.showsecurityLogModal
    ) {
      this.getSecurityLog('tableView',false);
      let elem = document.getElementById(this.props.location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  componentWillUpdate() {}

  componentDidUpdate(prevProps) {
    if (
      prevProps.securityThreats &&
      prevProps.securityThreats !== this.props.securityThreats
    ) {
      if (
        prevProps.securityThreatsRefresh &&
        !this.props.securityThreatsRefresh
      ) {
        this.setState((state) => ({ progress: true }));
      } else {
        this.setState((state) => ({ progress: false }));
      }
    }
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (
      !prevState.currentRecords &&
      nextProps.securityThreats &&
      nextProps.securityThreats.content &&
      nextProps.securityThreats.content.length
    ) {
      this.setState({
        currentRecords: this.buildDeviceSecurityThreatsData(nextProps),
      });
    }
  }
  onOpenModal = (type) => {
    this.setState({
      modal: true,
      modalType: type,
    });
  };
  modalCancelHandler = () => {
    this.setState({
      modal: false,
      modalType: null,
    });
  };

  buildDeviceSecurityThreatsData(props) {
    if (
      props.securityThreats &&
      props.securityThreats.content &&
      props.securityThreats.content.length
    ) {
      props.securityThreats.content.forEach((threat) => {
        threat.deviceName = this.getDeviceName(threat.deviceMac);
      });
      return props.securityThreats.content.map((threat) => {
        threat.deviceName = threat.deviceName || '';
        return threat;
      });
    } else {
      return [];
    }
  }

  makeRendererFn(timerStart) {
    var count = 0;
    if (timerStart) {
      count = Math.round((new Date() - timerStart) / 1000);
    }

    // console.log("clock starts with seconds:", count);
    return ({ minutes, seconds }) => {
      var secs = count % 60;
      var mins = Math.floor(count / 60);
      count++;
      return (
        <span>
          {mins}:{zeroPad(secs)}
        </span>
      );
    };
  }

  handleClick(event) {
    this.setState({ currentPage: Number(event.target.id) });
  }

  getSecurityLog(type, isClicked) {
      let payload = { refreshData: true, pageNumber: 0, size: 1000, maxDaysOld:30 };
      this.props.onGetAdvancedSecurityThreats(payload, isClicked);
   
  }
  openHandlerCreate() {
    this.setState({
      upArrowsCreate: true,
    });
  }
  closeHandlerCreate() {
    this.setState({
      upArrowsCreate: false,
    });
  }
  openHandlerM() {
    this.setState({
      upArrowsM: true,
    });
  }
  closeHandlerM() {
    this.setState({
      upArrowsM: false,
    });
  }
  openSecurityLogHandler(ind, row) {
    if (this.state.upArrows.includes(ind)) {
      this.state.upArrows.splice(this.state.upArrows.indexOf(ind), 1);
      this.setState({
        upArrows: this.state.upArrows,
      });
      this.setState({
        displayLogId: '',
      });
    } else {
      if (this.state.displayLogId !== '') {
        this.state.upArrows.splice(
          this.state.upArrows.indexOf(this.state.displayLogId),
          1
        );
      }
      this.setState({
        upArrows: this.state.upArrows.concat(ind),
      });
      this.setState({
        displayLogId: ind,
      });
    }
  }
  closeHandler(ind) {
    this.state.upArrows.splice(this.state.upArrows.indexOf(ind), 1);
    this.setState({
      upArrows: this.state.upArrows,
    });
  }

  sortTable = (propertyName) => {
    const { sortDirection, currentRecords } = this.state;
    const records = sortDataByKey(currentRecords, propertyName, sortDirection);
    this.setState({
      currentRecords: records,
      sortDirection:
        sortDirection === '' || sortDirection === 'desc' ? 'asc' : 'desc',
      sortBy: propertyName,
    });
  };

  getDeviceIconUrl = (deviceMAC) => {
    if (!deviceMAC) {
      return undefined;
    }
    if (!this.props.devices || !this.props.devices.advancedDeviceIds) {
      return undefined;
    }
    let adid = this.props.devices.advancedDeviceIds[deviceMAC];
    if (!adid) {
      return undefined;
    }
    let icons = adid.deviceIcons.icons;
    return icons['3x'] || icons['2x'] || icons['1x'];
  };

  getDeviceName = (deviceMac) => {
    if (!this.props.devicesByEquipment) {
      return deviceMac;
    }

    let devices = this.props.devicesByEquipment.filter(
      (d) => d.mac === deviceMac
    );

    let element = devices[0];
    if (element === undefined || element.length === 0 || element == null) {
      return deviceMac;
    }
    var deviceName;
    if (
      !element.nickname ||
      element.nickname === undefined ||
      (element.nickname && !element.nickname.length) ||
      element.nickname === null
    ) {
      deviceName = element.name;
    } else {
      if (element.nickname.indexOf('|') !== -1) {
        deviceName = element.nickname.slice(
          element.nickname.indexOf('|') + 1,
          element.nickname.length
        );
      } else deviceName = element.nickname;
    }

    if (deviceName === undefined || deviceName.length === 0) {

      if (element.mac) {
        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[element.mac] && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']) {
          if (this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel']
            && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel'] > 4) {
            deviceName = this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['model'] ? this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['model'] : (this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['type'] ? this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['type'] : '');
          }
        }
        if ((deviceName === undefined || deviceName.length === 0) && this.props.advancedDeviceIds && this.props.advancedDeviceIds[element.mac] && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']) {
          deviceName = this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['dhcpHostname'];
        }
        if (deviceName === undefined || deviceName.length === 0) {
          deviceName = element.mac;
        };
      }
      if (deviceName === undefined || deviceName.length === 0) {
        deviceName = "Unknown";
      }
    }
    return deviceName;
  };

  getSecurityLogRow = (row, ind) => {
    // console.log(row, 'test 271')
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrows.includes(ind)) {
      arrow = (
        <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
      );
    } else {
      arrow = (
        <MdKeyboardArrowDown
          aria-label="arrow downx"
          color={'gray'}
          size={'30px'}
        />
      );
    }
    let logDetailsId = 'LogDetails_' + ind;
    let logDetailsStyling;
    let tdBorder;
    let tdBottomBorder;
    // console.log('ID ::::', ind, '::::', this.state.displayLogId)
    if (this.state.displayLogId === ind) {
      logDetailsStyling = {
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: '1px solid lightgray',
      };

      tdBorder = '0px solid lightgray';
      tdBottomBorder = '0px solid lightgray';
    } else {
      logDetailsStyling = { display: 'none' };
      tdBorder = '1px solid lightgray';
      tdBottomBorder = '1px solid lightgray';
    }
    let deviceName = this.getDeviceName(row.deviceMac);
    let deviceIconUrl = this.getDeviceIconUrl(row.deviceMac);
    let threatUrl =
      row && row.details && row.details.url ? row.details.url : 'N/A';
    let threatRemotePort =
      row && row.details && row.details.remotePort
        ? row.details.remotePort
        : 'N/A';
    let threatRemoteIp =
      row && row.details && row.details.remoteIp ? row.details.remoteIp : 'N/A';
    let threatSourceIp =
      row && row.metadata && row.metadata.ip ? row.metadata.ip : 'N/A';
    let threatSourcePort =
      row && row.details && row.details.localPort
        ? row.details.localPort
        : 'N/A';
    let threatCategory = 'N/A';
      if(row &&
      row.details &&
      row.details.categories &&
      Array.isArray(row.details.categories)){
        threatCategory = row.details.categories.join(', ')
      }
      let threatAction = 'N/A';
      if(row && row.action){
          threatAction = row.action.charAt(0).toUpperCase() + row.action.slice(1); 
      }
      let threatActionBy = 'N/A';
      if(row && row.customerAction){
        if(row.customerAction === 'NO_ACTION'){
          threatActionBy = 'System';
        }else if(row.customerAction === 'IGNORE' || row.customerAction === 'UNBLOCK'){
          threatActionBy = 'Customer';
          threatAction = 'Unblock';
        }
        const currentTime = moment();
        const firstCondtion = ((row.customerAction === "UNBLOCK" && currentTime < row.expiresAt) &&
         (threatAction === "Ignore" && threatActionBy === "Customer"));

        const secondCondition = ((row.customerAction === "UNBLOCK") &&
        (threatAction == "Block" && threatActionBy === "Unblock Expiration"));

        const thirdCondtion = ((row.customerAction === "BLOCK") &&
        (threatAction == "Block" && threatActionBy === "Customer"));

        const fourthCondition =  (threatAction == "Block" && threatActionBy === "System");


        if(firstCondtion || secondCondition || thirdCondtion || fourthCondition) {
          threatAction = "Blocked 30 days"
        }
      }
       
    let threatType;
    if (row.type === 'MODEL_PROFILE') {
      threatType = 'Smart Device Protection';
      threatSourceIp = 'N/A';
      threatSourcePort = 'N/A';
      if(row.direction === 'OUT'){
        threatSourceIp = row && row.metadata && row.metadata.ip ? row.metadata.ip : 'N/A';
        threatRemoteIp = row && row.details && row.details.remoteIp ? row.details.remoteIp : 'N/A';
      }else if(row.direction === 'IN'){
        threatRemoteIp = row && row.metadata && row.metadata.ip ? row.metadata.ip : 'N/A';
        threatSourceIp = row && row.details && row.details.remoteIp ? row.details.remoteIp : 'N/A';
      }
    } else if (row.type === 'DOS') {
      threatType = 'Outbound DoS Prevention';
      threatAction = 'Blocked 7 Days';
      
      threatSourceIp = 'N/A';
      threatSourcePort = 'N/A';
      threatRemotePort = 'N/A';
      if(row.direction === 'OUT'){
        threatSourceIp = row && row.metadata && row.metadata.ip ? row.metadata.ip : 'N/A';
        threatRemoteIp = row && row.details && row.details.remoteIp ? row.details.remoteIp : 'N/A';
      }
      if(row.customerAction === "UNBLOCK" && currentTime < row.expiresAt){
        threatAction = "Ignore";
        threatActionBy = "Customer";
      }else if(row.customerAction === "UNBLOCK"){
        threatAction = "Block";
        threatActionBy = "Unblock Expiration"
      }else if(row.customerAction === "BLOCK"){
        threatAction = "Block";
        threatActionBy = "Customer";
      }else{
        threatAction = "Block";
        threatActionBy = "System";
      }
    } else if (row.type === 'IP_REPUTATION') {
      threatType = 'Secure Traffic';
      if(row.direction === 'IN'){
        threatRemoteIp = row && row.metadata && row.metadata.ip ? row.metadata.ip : 'N/A';
        threatSourceIp = row && row.details && row.details.remoteIp ? row.details.remoteIp : 'N/A';
        threatSourcePort = row && row.details && row.details.remotePort ? row.details.remotePort : 'N/A';
      }else if(row.direction === 'OUT'){ 
        threatRemoteIp = row && row.details && row.details.remoteIp ? row.details.remoteIp : 'N/A';
        threatSourceIp = row && row.metadata && row.metadata.ip ? row.metadata.ip : 'N/A';
        threatSourcePort = row && row.details && row.details.localPort ? row.details.localPort : 'N/A';
      
      }
      // threatRemoteIp = 'N/A';
      // threatSourceIp = 'N/A';
      // threatSourcePort = 'N/A';
      threatRemotePort = 'N/A';
    } else if (row.type === 'SAFE_BROWSING') {
      threatType = 'Secure Browsing';
      if(row.direction === 'OUT'){
        threatUrl = row && row.details && row.details.url ? row.details.url : 'N/A';
      }
      threatRemoteIp = 'N/A';
      threatSourceIp = 'N/A';
      threatSourcePort = 'N/A';
      threatRemotePort = 'N/A';
      if(row.customerAction === "UNBLOCK" && currentTime < row.expiresAt){
        threatAction = "Ignore";
        threatActionBy = "Customer";
      }else if(row.customerAction === "UNBLOCK"){
        threatAction = "Block";
        threatActionBy = "Unblock Expiration"
      }else if(row.customerAction === "BLOCK"){
        threatAction = "Block";
        threatActionBy = "Customer";
      }else{
        threatAction = "Block";
        threatActionBy = "System";
      }
    }
    return (
      <Box>
        <tr className={classes.trTag}>
          <td
            style={{
              borderRight: '2px solid lightgray',
              borderLeft: 'none',
              borderBottom:  tdBottomBorder ,
              display: 'flex',
            }}
          >
            <div className={ classes.devicenameStyling }>
            <DeviceIcon size={30} iconUrl={deviceIconUrl} />
            <span
              id="SecurityLogDeviceName"
              style={{
                marginLeft: '10px',
                width: '150px',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                paddingTop: '4px'
              }}
              className={[
                classes.devName,
                classes.deviceNameRegularButton,
              ].join(' ')}
            >
              {deviceName}
            </span>
            </div>
          </td>
          <td
            style={{
              borderRight: 'none',
              borderLeft: 'none',
              borderBottom:  tdBottomBorder ,
            }}
          >
            <div className={ classes.threatTypeStyling }>
            <FaInfoCircle
              id = 'ThreadIcon'
              color="#38a9f9"
              size={15}
              style={{ paddingTop:'8px' }}
              onClick={() => this.onOpenModal(row.type)}
            />{' '}
            <span id ='ThreadType' className={ classes.threatTypeTextStyling }>{threatType}</span>            
            </div>
          </td>
          <td
            style={{
              padding: '10px 10px 5px 10px',
              borderRight: 'none',
              borderLeft: 'none',
              borderBottom:  tdBottomBorder,
            }}
          >
            <Moment format="ddd MM/DD/YYYY hh:mm A" date={row.startedAt} />
          </td>
          <td
            style={{
              padding: '10px',
              borderRight: 'none',
              borderLeft: 'none',
              borderBottom:  tdBottomBorder,
            }}
          >
            <div className={classes.CellAreaTiny}>
              <button
              style={{ paddingTop:'12px' }}
                id="openArrow"
                className={classes.OpenCloseButton}
                onClick={() => {
                  this.openSecurityLogHandler(ind, row);
                }}
              >
                {arrow}
              </button>
            </div>
          </td>
        </tr>

        <tr id={logDetailsId} style={logDetailsStyling}>
          <td className={classes.mobileStyling} style={{ borderRight: '2px solid lightgray', borderBottom :'1px solid #ccc' }}></td>
          <td className={classes.mobileStyling} colSpan="3" style={{ borderBottom :'1px solid #ccc' }}>
            <div className={classes.BodyArea} style={{ display: 'flex' }}>
              <div style={{ width: '100%' }}>
                <div className={classes.flexContainer}>
                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div id="dhcptoggle" style={{ flex: '1' }}>
                      Threat Action:
                    </div>
                    <div
                      id="threatAction"
                      style={{ color: '#666', flex: '1', textAlign: 'left' }}
                    >
                      {threatAction}{' '}
                    </div>
                  </div>
                </div>

                <div className={classes.flexContainer}>
                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div style={{ flex: '1' }}>Category:</div>
                    <div
                      id="threatCategory"
                      style={{ color: '#666', flex: '1' }}
                    >
                      {' '}
                      {threatCategory?threatCategory:'N/A'}
                    </div>
                  </div>

                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div style={{ flex: '1' }}>Action By:</div>
                    <div
                      id="threatActionBy"
                      style={{ color: '#666', flex: '1' }}
                    >
                     {threatActionBy}
                    </div>
                  </div>
                </div>

                <div className={classes.flexContainer}>
                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div style={{ flex: '1' }}>Destination IP:</div>
                    <div
                      id="threatDestinationIP"
                      style={{ color: '#666', flex: '1', wordBreak : 'break-word' }}
                    >
                      {threatRemoteIp}
                    </div>
                  </div>

                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div style={{ flex: '1' }}>Destination Port:</div>
                    <div id="threatPort" style={{ color: '#666', flex: '1' }}>
                      {threatRemotePort}
                    </div>
                  </div>
                </div>

                <div className={classes.flexContainer}>
                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div style={{ flex: '1' }}>Source IP:</div>
                    <div
                      id="threatSourceIP"
                      style={{ color: '#666', flex: '1', wordBreak : 'break-word' }}
                    >
                      {' '}
                      {threatSourceIp}
                    </div>
                  </div>
                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div style={{ flex: '1' }}>Source Port:</div>
                    <div
                      id="threatSourcePort"
                      style={{ color: '#666', flex: '1' }}
                    >
                      {threatSourcePort}
                    </div>
                  </div>
                 
                </div>

                <div className={classes.flexContainer}>
                  <div
                    className={classes.flexContainer}
                    style={{ flex: '1 1' }}
                  >
                    <div id="dhcptoggle" style={{ flex: '1' }}>
                      Threat URL/IP:
                    </div>
                    <div id="threatURL" style={{ color: '#666', flex: '1', wordBreak:'break-word' }}>
                      {threatUrl}{' '}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </Box>
    );
  };

  getSecurityLogRows = (data) => {
    if (
      this.props.securityThreats === null ||
      !this.props.securityThreatsLoaded ||
      this.props.securityThreats === undefined ||
      (this.props.securityThreats &&
        this.props.securityThreats.numberOfElements &&
        this.props.securityThreats.numberOfElements === 0) ||
      (this.props.securityThreats &&
        this.props.securityThreats.content &&
        this.props.securityThreats.content.length === 0)
    ) {
      return [];
    }
    if (data && data.length > 0) {
      return data.map((g, ind) => this.getSecurityLogRow(g, ind));
    } else {
      return (
        <tr className={classes.trTag}>
          <td colspan="4" style={{ textAlign: 'center' }}>
            No Security Threats Logged.
          </td>
        </tr>
      );
    }
  };

  getSecurityLogTable = (data) => {
    // console.log('secuirty Table ::::', this.state, this.props);
    let sortIcon;
    const { sortDirection, sortBy } = this.state;
    if (sortDirection === 'asc') {
      sortIcon = <FaSortUp fontSize={'12px'} />;
    } else if (sortDirection === 'desc' || sortDirection === '') {
      sortIcon = <FaSortDown fontSize={'12px'} />;
    }
    if (
      !this.props.securityThreatsLoaded ||
      (this.props.securityThreats && this.props.securityThreats.length === 0) ||
      this.props.securityThreatsRefresh
    ) {
      return (
        <div className={classes.securityLogMessage}>
          <div className={classes.ShortTitleArea}>
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <div>
                <FaSpinner
                  fontSize={'25px'}
                  style={{ color: '#0073d1', marginRight: '5px' }}
                  className={[
                    classes.fa,
                    classes.facircleonotch,
                    classes.faspin,
                    classes.fa3x,
                    classes.fafw,
                  ].join(' ')}
                />
              </div>

              <div id="LogSpinnerText">
                {' '}
                Please wait gathering Security Log details.{' '}
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (
      this.props.securityThreatsLoaded &&
      this.props.securityThreats &&
      this.props.securityThreats.numberOfElements &&
      this.props.securityThreats.numberOfElements > 0
    ) {
      let tableForDesktop = (
        <div className={classes.securitylogtablewrapper}>
          <table className={classes.devTable} cellPadding="0" cellSpacing="0">
            <thead>
              <tr className={classes.trTag}>
                <th id = 'AdvSecDevice'
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceName');
                  }}
                >
                  Device {sortBy === 'deviceName' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('type');
                  }}
                >
                  Threat Type {sortBy === 'type' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('startedAt');
                  }}
                >
                  Date & Time {sortBy === 'startedAt' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                ></th>
              </tr>
            </thead>
            <tbody>{this.getSecurityLogRows(data)}</tbody>
          </table>
        </div>
      );

      return tableForDesktop;
    } else {
      return (
        <div className={classes.securityLogMessage}>
          <div className={classes.ShortTitleArea}>
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <div id="securityThreatInfo">No Security Threats Logged. </div>
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    // console.log('Security Log  :::', this.props);
    let securityLogInfo;
    let actionsInfo;
    let securityThreats;
    let totalThreatsCount =
      this.props.securityThreats && this.props.securityThreats.totalElements
        ? this.props.securityThreats.totalElements
        : 0;
    let renderPageNumbers;
    let renderStatus;
    let displayPagination;
    let closeBtn = (
      <span
        id="cancelX"
        onClick={this.modalCancelHandler}
        style={{ float: 'right', color: '#0073d1', cursor: 'pointer' }}
      >
        X Close
      </span>
    );
    if (this.state.modalType === 'SAFE_BROWSING') {
      actionsInfo = this.props.securityLogInfo.SAFE_BROWSING.actions.map(
        (el, ind) => {
          return (
            <p>
              {this.props.securityLogInfo.SAFE_BROWSING.actions[ind].body}
              <a
                href={
                  this.props.securityLogInfo.SAFE_BROWSING.actions[ind].link.url
                }
                target="_blank"
              >
                {' '}
                {
                  this.props.securityLogInfo.SAFE_BROWSING.actions[ind].link
                    .display
                }{' '}
              </a>
            </p>
          );
        }
      );
      securityLogInfo = (
        <div>
          {closeBtn}
          <h3>{this.props.securityLogInfo.SAFE_BROWSING.title}</h3>
          <p>{this.props.securityLogInfo.SAFE_BROWSING.body}</p>
          <h3>{this.props.securityLogInfo.SAFE_BROWSING.actionsTitle}</h3>
          {actionsInfo}
        </div>
      );
    }else if (this.state.modalType === 'IP_REPUTATION') {
      actionsInfo = this.props.securityLogInfo.IP_REPUTATION.actions.map(
        (el, ind) => {
          return (
            <p>
              {this.props.securityLogInfo.IP_REPUTATION.actions[ind].body}
              <a
                href={
                  this.props.securityLogInfo.IP_REPUTATION.actions[ind].link.url
                }
                target="_blank"
              >
                {' '}
                {
                  this.props.securityLogInfo.IP_REPUTATION.actions[ind].link
                    .display
                }{' '}
              </a>
            </p>
          );
        }
      );
      securityLogInfo = (
        <div>
          {closeBtn}
          <h3>{this.props.securityLogInfo.IP_REPUTATION.title}</h3>
          <p>{this.props.securityLogInfo.IP_REPUTATION.body}</p>
          <h3>{this.props.securityLogInfo.IP_REPUTATION.actionsTitle}</h3>
          {actionsInfo}
        </div>
      );
    }
    // else if (this.state.modalType === 'REMOTE_ACCESS') {
    //   actionsInfo = this.props.securityLogInfo.REMOTE_ACCESS.actions.map(
    //     (el, ind) => {
    //       return (
    //         <p>
    //           {this.props.securityLogInfo.REMOTE_ACCESS.actions[ind].body}
    //           <a
    //             href={
    //               this.props.securityLogInfo.REMOTE_ACCESS.actions[ind].link.url
    //             }
    //             target="_blank"
    //           >
    //             {' '}
    //             {
    //               this.props.securityLogInfo.REMOTE_ACCESS.actions[ind].link
    //                 .display
    //             }{' '}
    //           </a>
    //         </p>
    //       );
    //     }
    //   );
    //   securityLogInfo = (
    //     <div>
    //       {closeBtn}
    //       <h3>{this.props.securityLogInfo.REMOTE_ACCESS.title}</h3>
    //       <p>{this.props.securityLogInfo.REMOTE_ACCESS.body}</p>
    //       <h3>{this.props.securityLogInfo.REMOTE_ACCESS.actionsTitle}</h3>
    //       {actionsInfo}
    //     </div>
    //   );
    // }
    else if (this.state.modalType === 'MODEL_PROFILE') {
      actionsInfo = this.props.securityLogInfo.MODEL_PROFILE.actions.map(
        (el, ind) => {
          return (
            <p>
              {this.props.securityLogInfo.MODEL_PROFILE.actions[ind].body}
              <a
                href={
                  this.props.securityLogInfo.MODEL_PROFILE.actions[ind].link.url
                }
                target="_blank"
              >
                {' '}
                {
                  this.props.securityLogInfo.MODEL_PROFILE.actions[ind].link
                    .display
                }{' '}
              </a>
            </p>
          );
        }
      );
      securityLogInfo = (
        <div>
          {closeBtn}
          <h3>{this.props.securityLogInfo.MODEL_PROFILE.title}</h3>
          <p>{this.props.securityLogInfo.MODEL_PROFILE.body}</p>
          <h3>{this.props.securityLogInfo.MODEL_PROFILE.actionsTitle}</h3>
          {actionsInfo}
        </div>
      );
    }else if (this.state.modalType === 'DOS') {
      actionsInfo = this.props.securityLogInfo.DOS.actions.map((el, ind) => {
        return (
          <p>
            {this.props.securityLogInfo.DOS.actions[ind].body}
            <a
              href={this.props.securityLogInfo.DOS.actions[ind].link.url}
              target="_blank"
            >
              {' '}
              {this.props.securityLogInfo.DOS.actions[ind].link.display}{' '}
            </a>
          </p>
        );
      });
      securityLogInfo = (
        <div>
          {closeBtn}
          <h3>{this.props.securityLogInfo.DOS.title}</h3>
          <p>{this.props.securityLogInfo.DOS.body}</p>
          <h3>{this.props.securityLogInfo.DOS.actionsTitle}</h3>
          {actionsInfo}
        </div>
      );
    }
    if (
      (this.state.progress && this.props.securityThreatsRefresh) ||
      (this.state.progress && this.props.securityThreatsLoaded)
    ) {
      const { currentPage, itemsPerPage } = this.state;

      // Logic for displaying current rec
      const indexOfLast = currentPage * itemsPerPage;
      const indexOfFirst = indexOfLast - itemsPerPage;
      const currentRecords = this.state.currentRecords.slice(
        indexOfFirst,
        indexOfLast
      );

      securityThreats = this.getSecurityLogTable(currentRecords);
      if (this.props.securityThreatsLoaded) {
        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(totalThreatsCount / itemsPerPage); i++) {
          pageNumbers.push(i);
        }

        if (pageNumbers.length > 1) {
          renderPageNumbers = pageNumbers.map((number) => {
            const baseClassName = [classes.pagination];
            const activeClassName =
              number === this.state.currentPage
                ? [classes.paginationactive]
                : '';
            return (
              <div
                className={`${baseClassName} ${activeClassName}`}
                key={number}
                id={number}
                onClick={this.handleClick}
                style={{ float: 'left', paddingTop: 5 }}
              >
                {number}
              </div>
            );
          });
          displayPagination = (
            <div style={{ width: '100%', height: '50px' }}>
              <span style={{ float: 'right', paddingTop: '7px' }}>
                {renderPageNumbers}
              </span>
            </div>
          );
        }

        renderStatus = (
          <button
            id="securityLogRefresh"
            className={classes.RegularButton}
            onClick={() => {
              this.getSecurityLog('refresh', true);
            }}
          >
            <FaSync /> Refresh
          </button>
        );
      } else {
        renderStatus = (
          <span id="securityLogInprogress" className={classes.RegularButton}>
            In Progress
          </span>
        );
      }
    } else {
      renderStatus = (
        <button
          id="securityLogCheck"
          className={classes.RegularButton}
          onClick={() => {
            this.getSecurityLog('tableView', true);
          }}
        >
          Get Log
        </button>
      );
      actionsInfo = this.props.securityLogInfo.DOS.actions.map((el, ind) => {
        return (
          <p>
            {this.props.securityLogInfo.DOS.actions[ind].body}
            <a
              href={this.props.securityLogInfo.DOS.actions[ind].link.url}
              target="_blank"
            >
              {' '}
              {this.props.securityLogInfo.DOS.actions[ind].link.display}{' '}
            </a>
          </p>
        );
      });
      securityLogInfo = (
        <div>
          {closeBtn}
          <h3>{this.props.securityLogInfo.DOS.title}</h3>
          <p>{this.props.securityLogInfo.DOS.body}</p>
          <h3>{this.props.securityLogInfo.DOS.actionsTitle}</h3>
          {actionsInfo}
        </div>
      );
    }
    // console.log('Security Log Props ::', this.props);
    return (
      <Box>
        <div className={classes.SecurityLog}>
          <div className={classes.TitleArea}>
            <div className={classes.TitleLeft}>
              <h3 id="SISLog" className={classes.ComponentTitle}>
              Security Shield Log
              </h3>
            </div>
            <div className={classes.TitleRight}>{renderStatus}</div>
          </div>
          <div id="advancedSecurityLogSection" className={classes.BodyArea}>
            {securityThreats}
            {displayPagination}
          </div>
        </div>
        <Modal show={this.state.modal} modalClosed={this.modalCancelHandler}>
          {securityLogInfo}
        </Modal>
      </Box>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    securityThreats: state.securityThreats.securityThreats,
    oneDayTotal:state.securityThreats.oneDayTotal,
    securityThreatsLoaded: state.securityThreats.securityThreatsLoaded,
    securityThreatsRefresh: state.securityThreats.securityThreatsrefresh,
    devices: state.devices,
    devicesByEquipment: state.devices.devicesByEquipment,
    securityLogInfo: state.securityThreats.securityLogInfo,
    advancedDeviceIds: state.devices.advancedDeviceIds,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetAdvancedSecurityThreats: (payload, isClicked) =>
      dispatch(actions.getAdvancedSecurityThreats(payload, isClicked)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withErrorHandler(SecurityLog, api)));
